<div
  awCloseOnOffClick
  class="border-standard-outline-light bg-standard-background w-72 rounded-lg border p-3 shadow-lg"
  (onOffClick)="closed.emit()">
  <p class="text-standard-text-primary mb-3">
    {{ cmsTextProvider.configuration.chooseWhichProduct }}
  </p>
  <div class="flex items-center justify-end gap-2">
    <button
      class="text-primary-main hover:bg-outlined-hover cursor-pointer rounded-md px-3 py-2"
      type="button"
      (click)="closed.emit()">
      {{ cmsTextProvider.shared.cancel }}
    </button>
    <button
      class="border-primary-main text-primary-main hover:bg-outlined-hover cursor-pointer rounded-md border px-4 py-2"
      type="button"
      (click)="channelSelected.emit(channel.Web)">
      {{ cmsTextProvider.license.web }}
    </button>
    <button
      class="border-primary-main text-primary-main hover:bg-outlined-hover cursor-pointer rounded-md border px-4 py-2"
      type="button"
      (click)="channelSelected.emit(channel.App)">
      {{ cmsTextProvider.license.app }}
    </button>
  </div>
</div>
